import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/material/styles';
import { ReactNode } from 'react';

export default function WithCard({
  children,
  show = true,
  sx = {},
}: {
  children: ReactNode;
  show?: boolean;
  sx?: SxProps;
}) {
  if (show) return <Card sx={{ width: '100%', ...sx }}>{children}</Card>;

  return (
    <Stack direction='column' sx={{ width: '100%', height: '100%' }}>
      {children}
    </Stack>
  );
}
